import { useMutation, useQueryClient } from 'react-query'
import { useSvcCompareVersionsContext } from '@dc-shared-web/providers'
import { deleteChangeNote } from '@dc-shared-web/hooks/api/comparison/deleteChangeNote'
import { COMPARISON_DATA_QUERY_KEY } from '@dc-shared-web/hooks/api/queryKeys'

interface DeleteChangeNoteMutationParams {
  changeUuid: string
  noteUuid: string
}

interface DeleteChangeNoteResponse {
  detail: string
}

export const useDeleteChangeNote = () => {
  const svcCompareVersionApiClient = useSvcCompareVersionsContext()
  const queryClient = useQueryClient()

  return useMutation<
    DeleteChangeNoteResponse,
    Error,
    DeleteChangeNoteMutationParams
  >({
    mutationFn: ({ changeUuid, noteUuid }) =>
      deleteChangeNote(svcCompareVersionApiClient, changeUuid, noteUuid),
    onSuccess: () => {
      // Invalidate comparison data queries to refetch with updated notes
      queryClient.invalidateQueries([COMPARISON_DATA_QUERY_KEY])
    },
  })
}
